export function importAllImages(context) {
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

  return context
    .keys()
    .sort((a, b) => collator.compare(a, b))
    .map(context);
}